import { Box, Typography } from '@mui/material';
import { tokens } from '../theme';

interface SpecWindowProps {
  min?: number;
  max?: number;
  value?: number | null;
  status: 'ok' | 'warning' | 'error' | 'missing';
  decimals?: number;
  unit?: string;
}

function pct(value: number, scale: number): number {
  return Math.max(0, Math.min(100, (value / scale) * 100));
}

export default function SpecWindow({
  min,
  max,
  value,
  status,
  decimals = 2,
  unit = '%',
}: SpecWindowProps) {
  const scale = Math.max(max ?? 0, min ?? 0, value ?? 0, 0.01) * 1.2;
  const bandStart = pct(min ?? 0, scale);
  const bandEnd = pct(max == null ? scale : max, scale);
  const bandWidth = Math.max(3, bandEnd - bandStart);
  const out = status === 'error';
  const measured = status !== 'missing' && value != null ? value : null;

  const fmt = (n?: number) => (n == null ? '—' : n.toFixed(decimals));

  return (
    <Box>
      <Box
        sx={{
          position: 'relative',
          height: 8,
          bgcolor: tokens.soft,
          borderRadius: 99,
          mt: 1.5,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: `${bandStart}%`,
            width: `${bandWidth}%`,
            bgcolor: out ? tokens.badBand : tokens.okBand,
            borderRadius: 99,
          }}
        />
        {measured != null && (
          <Box
            sx={{
              position: 'absolute',
              top: -4,
              left: `${pct(measured, scale)}%`,
              width: out ? 3 : 2,
              height: 16,
              bgcolor: out ? tokens.bad : tokens.fg,
              borderRadius: 99,
              transform: 'translateX(-50%)',
            }}
          />
        )}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        <Typography variant="caption" color="text.secondary">
          0
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Soll {fmt(min)}–{fmt(max)} {unit}
        </Typography>
      </Box>
    </Box>
  );
}
